import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { FarmService } from 'src/app/services/farm-service.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

declare const $: any;

@Component({
  selector: 'smart-calendar-image-list',
  templateUrl: './calendar-image-list.component.html',
  styleUrls: ['./calendar-image-list.component.scss', "../../platform-color/platform-color.css",],
})
export class CalendarImageListComponent implements OnInit {
  form: FormGroup;
  farmId: string;
  plotId: string;
  noDataModal: string ="#noDataModal";
  modalSlides: string ="#modalSlides";
  thingNotfoundModal: string ="#thingNotfoundModal";
  days = [];
  rows = [];
  medias = [];
  mediaList = [];
  cameras = [];

  loading: boolean = false;
  urlUpload: string = environment.URLUPLOADMNG;
  thingInfo = null;
  thingList = [];
  constructor(
    private FarmService: FarmService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private cd: ChangeDetectorRef
  ) { 
    this.activatedRoute.queryParams.subscribe(params => {
      this.plotId = params['plotId'];
      this.farmId = params['farmId'];
  });
  }

  async ngOnInit() {
    this.createForm();
    this.getCalendar();
    this.getThing();
  }

  createForm() {
    this.form = this.formBuilder.group({
      thing_id : [""],
      camera_name: [""],
      file_type: ["image"],
      date: [new Date()]
    });
  }

  getCalendar(){
    let month = new Date(this.form.value.date).getMonth();
    let year = new Date(this.form.value.date).getFullYear();
    this.rows = this.getRowsInMonth(month,year);
  }

  async getThing(){
    this.FarmService.getThingById(this.farmId, this.plotId).subscribe(res=>{
      if(res.code ==200){
        this.thingList = res.data;
      }
    })
  }

  async getCamera(){
    this.spinner.show();
    this.FarmService.getCamera(this.form.value.thing_id).subscribe(res=>{
      if(res.code ==200){
        this.cameras = res.data.cameraList;
        
        if(this.cameras.length == 0){
          $(`${this.thingNotfoundModal}`).modal("show");
        }else{
          this.form.get("camera_name").setValue(this.cameras[0].camera_name);

          this.getMedia();
        }
        this.spinner.hide();
      }else{
        this.medias= [];
        this.cameras = [];
        $(`${this.thingNotfoundModal}`).modal("show");
        this.spinner.hide();
      }
    })
  }

  getMedia(){
    this.loading = true;
    this.spinner.show();
    let filter = {
      file_type: this.form.value.file_type,
    }
    if(this.form.value.camera_name){
      filter["camera_name"] = this.form.value.camera_name;
    }
    if(this.form.value.date){
      var date = new Date(this.form.value.date);
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

      filter["start_date"] = this.dateFormat(firstDay);
      filter["end_date"] = this.dateFormat(lastDay);;
    }
    if(this.form.value.thing_id){
      this.FarmService.getMedia(this.form.value.thing_id, filter).subscribe(res=>{
        if(res.code ==200){
          this.medias = res.data.map(item=>{
            return { 
              ...item,
              date: moment(item.receive_date).utc(false).date()
            }
          });
        }else{
          this.medias= [];
        }
  
        this.loading = false;
        this.spinner.hide();
      })
    }else{
      this.loading = false;
      this.spinner.hide();
    }
  }

  dateFormat(date) {
    var datenow = new Date(date);
    return moment(datenow).utc(true).format('YYYY-MM-DD');
  }

  getRowsInMonth(month, year) {
    var monthIndex = month;

    var date = moment(new Date(year, monthIndex, 1));
    var lastDay = moment(new Date(year, month + 1, 0));
    var result = [];
    var days = [];

    for(var i= 1; i <= lastDay.date(); i++){
      if(date.day() == 6){
        days.push(
          {
            date: date.date(),
            day: date.day()
          }
        );
        date.add(1, 'days');

        result.push(days);
        days = [];
        
      }else{
        days.push(
          {
            date: date.date(),
            day: date.day()
          }
        );
        date.add(1, 'days');

        if(lastDay.date() == i){

          result.push(days);
        }
      }
    }
    return result;
  }

  showDay(days, number){
    let day = days.map(day=>{
      return day.day
    })
    return day.includes(number)? true: false;
  }

  getDate(days, number){
    return days.find(day=> day.day == number).date;
  }

  showMessageNoData(){
    $(`${this.noDataModal}`).modal("show");
  }

  openLightbox(days, number){
    var date = this.getDate(days, number);
    var media = this.medias.filter(media => media.date == date);
    var medias = [];
    if(media.length > 0){
      media.map(item=> {
        item.media.map(img=>{
          medias.push(img);
        })
      })
      this.mediaList = medias;
      setTimeout(() => {
        $(`${this.modalSlides}`).modal("show");
      }, 100);
    }else{
      this.showMessageNoData();
    }
  }

  showImage(days, number){
    var date = this.getDate(days, number);
    var media = this.medias.find(media => media.date == date);
    if(media){
      return true
    }
    return false;
  }

  getImage(days, number){
    var date = this.getDate(days, number);
    var media = this.medias.filter(media => media.date == date);

    if(media.length > 0){
      return  this.urlUpload + media[0].media[0].file_path.replace('/app', '');
    }
    return "";
  }

  changeThingName(value){
    this.form.get("thing_id").setValue(value);
    this.form.get("thing_id").updateValueAndValidity();
    if(value){
      this.getCamera();
    }else{
      this.medias= [];
      this.cameras = [];
    }
  }

  changeCameraName(value){
    this.form.get("camera_name").setValue(value);
    this.form.get("camera_name").updateValueAndValidity();

    this.getMedia();
  }

  changeDate(value){
    this.form.get("date").setValue(value);
    this.form.get("date").updateValueAndValidity();
    this.getCalendar();
    this.getMedia();
  }

  capture(){

    if(this.form.value.thing_id){
      let data = {
        ThingId: this.form.value.thing_id,
        Control: "capture1",
        Value: 1,
      };
  
      this.FarmService.getControlCamerabyId(data).subscribe(async (success) => {
  
        if (success.code == 200) {
  
          if (success.data) {
            if (success.data.OperationStatus.Code == 20000) {
              Swal.fire({
                title: "ดำเนินการเสร็จสิ้น",
                timer: 2000,
                icon: "success",
                timerProgressBar: true,
                showConfirmButton: false,
                allowOutsideClick: false,
                onClose: () => {
                },
              });
            } else {
              Swal.fire({
                title: "กรุณาลองใหม่อีกครั้ง",
                timer: 2000,
                icon: "error",
                timerProgressBar: true,
                showConfirmButton: false,
                allowOutsideClick: false,
                onClose: () => {
                },
              });
            }
          } else {
            Swal.fire({
              title: "ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้",
              timer: 2000,
              icon: "error",
              timerProgressBar: true,
              showConfirmButton: false,
              allowOutsideClick: false,
              onClose: () => {
                //this.spinner.hide();
              },
            });
          }
        }
      });
    }
  }
}
